import type { ChangeEvent } from 'react';
import type { VodChapter } from 'src/generated/graphql-manager';

import { IconButton, ImageIcon, TrashIcon } from '@movingimage-evp/mi-ui-component-library';
import { useTranslation } from 'react-i18next';

import styles from './event-summary-chapters.module.css';

type ChapterThumbnailProps = {
  chapter: VodChapter;
  index: number;
  onFileChange: (event: ChangeEvent<HTMLInputElement>, chapterId: VodChapter['id']) => void;
  onRemoveThumbnail: (chapterId: VodChapter['id']) => void;
};

export function ChapterThumbnail({ chapter, index, onFileChange, onRemoveThumbnail }: ChapterThumbnailProps) {
  const { t } = useTranslation();
  const thumbnailSrc = chapter.thumbnail.downloadLink;

  if (thumbnailSrc)
    return (
      <div
        data-testid={`chapter-${index + 1}-thumbnail`}
        className={styles.thumbnail}
        style={{ backgroundImage: `url(${thumbnailSrc})`, position: 'relative' }}
      >
        <IconButton
          data-testid={`chapter-${index + 1}-remove-thumbnail-button`}
          aria-label={t('manager.eventSummary.chapters.removeThumbnail')}
          small
          className={styles.removeThumbnailButton}
          onClick={() => onRemoveThumbnail(chapter.id)}
        >
          <TrashIcon />
        </IconButton>
      </div>
    );

  return (
    <div className={styles.fileInput}>
      <input
        data-testid={`chapter-${index + 1}-thumbnail-file-input`}
        type="file"
        accept="image/*"
        onChange={(event) => onFileChange(event, chapter.id)}
      />

      <ImageIcon />
      {t('manager.eventSummary.chapters.uploadThumbnail')}
    </div>
  );
}
